"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RW_DESKTOP_DETECTOR_REGEX = exports.EIKON_DESKTOP_DETECTOR_REGEX = exports.RTK_DETECTOR_OBJECT = exports.SXS_WEB_DETECTOR_OBJECT = exports.WORKSPACE_SDK_DETECTOR_OBJECT = exports.ExecutionContainer = exports.TransportType = exports.Platform = exports.APP_DEFAULT_SCOPE = exports.RW_REQUEST_PREFIX = exports.TSI_ENDPOINT_ROOT = exports.UDF_ENDPOINT_ROOT = exports.RDP_ENDPOINT_ROOT = void 0;
exports.RDP_ENDPOINT_ROOT = '/api/rdp';
exports.UDF_ENDPOINT_ROOT = '/api/udf';
exports.TSI_ENDPOINT_ROOT = '/api/rdp/data/historical-pricing/v1/metadata';
exports.RW_REQUEST_PREFIX = '/eds';
exports.APP_DEFAULT_SCOPE = 'trapi';
var Platform;
(function (Platform) {
    Platform["ALPHA"] = "alpha";
    Platform["BETA"] = "beta";
    Platform["PROD"] = "prod";
})(Platform || (exports.Platform = Platform = {}));
var TransportType;
(function (TransportType) {
    TransportType["PIPE"] = "PIPE";
})(TransportType || (exports.TransportType = TransportType = {}));
var ExecutionContainer;
(function (ExecutionContainer) {
    ExecutionContainer["DESKTOP_RW_1_9"] = "DESKTOP_RW_1_9";
    ExecutionContainer["DESKTOP_RW_NON_1_9_OR_EIKON"] = "DESKTOP_RW_NON_1_9_OR_EIKON";
    ExecutionContainer["RTK"] = "RTK";
    ExecutionContainer["SXS_WEB"] = "SXS_WEB";
    ExecutionContainer["WORKSPACE_SDK"] = "WSDK";
    ExecutionContainer["WEB_RW_OR_EIKON"] = "WEB_RW_OR_EIKON";
    ExecutionContainer["UNKNOWN"] = "UNKNOWN";
})(ExecutionContainer || (exports.ExecutionContainer = ExecutionContainer = {}));
exports.WORKSPACE_SDK_DETECTOR_OBJECT = 'WSDK';
exports.SXS_WEB_DETECTOR_OBJECT = 'sxsWeb';
exports.RTK_DETECTOR_OBJECT = 'RTK';
exports.EIKON_DESKTOP_DETECTOR_REGEX = /EikonViewer/i;
exports.RW_DESKTOP_DETECTOR_REGEX = /(TR-EikonLight|RefinitivWorkspace)/i;
